export default {
  X: '--ws-position-x',
  Y: '--ws-position-y',
};
